import { setSelectedOrderGroupKeys } from '../../../State/selectedOrderGroupKeys';
import { setShowValuationCompletionModal } from '../../../State/showValuationCompletionModal';

export default ({ orderIndex, orderGroupIndex }) => async (dispatch) => {

  dispatch(setSelectedOrderGroupKeys({ orderIndex, orderGroupIndex }));
  dispatch(setShowValuationCompletionModal(true));

}